import { useState, useEffect } from "react"
// import { API, graphqlOperation } from "aws-amplify"
import { listEvents } from "../graphql/queries"

// function createDateLimit() {
//   const dateLimit = new Date()
//   dateLimit.setDate(dateLimit.getDate() + 1)
//   return dateLimit
// }

// function sortEventsByDate(events: EventInfo[]) {
//   return events.sort((a: EventInfo, b: EventInfo) =>
//     a.start < b.start ? -1 : a.start > b.start ? 1 : 0
//   )
// }

// async function getEvents(
//   name: string,
//   setEvents: (events: EventInfo[]) => void
// ) {
//   const dateLimit = createDateLimit()
//   const response = await API.graphql(
//     graphqlOperation(listEvents, {
//       filter: {
//         experienceID: { eq: name },
//         start: { gt: dateLimit.toISOString() },
//       },
//       limit: 150,
//     })
//   )
//   setEvents(sortEventsByDate(response.data.listEvents.items))
// }

export default function useGetEventsByExperienceName(
  name: string,
  setLoading: (isLoading: boolean) => void
) {
  const [events, setEvents] = useState<EventInfo[]>([])

  useEffect(() => {
    // getEvents(name, setEvents)
    // setLoading(false)
  }, [])
  return events
}
